import { useNavigate } from 'react-router';

import { useI18n } from '@app-velocity/i18n';
import { ArrowForwardIcon } from '@app-velocity/icons';

import { ScenarioRoutePaths } from '@app-velocity/modules/scenarios';

import { useSimulationWidgetContext } from '../../../../../../hooks/useSimulationWidgetContext';
import { ActionButton } from '../ActionButton';

export const ActionDetails = () => {
  const { t } = useI18n();
  const navigate = useNavigate();

  const { latestReview, workspaceId, teamId, scenarioId } =
    useSimulationWidgetContext();

  const openDetails = () => {
    if (!latestReview?.reviewId || !workspaceId || !teamId || !scenarioId)
      return;

    navigate(
      ScenarioRoutePaths.challengeSimulation(
        teamId,
        workspaceId,
        scenarioId,
        latestReview.reviewId
      )
    );
  };

  if (latestReview?.type !== 'SINGLE') return null;

  return (
    <ActionButton onClick={openDetails}>
      {t('prototypes:see_details')} <ArrowForwardIcon />
    </ActionButton>
  );
};
